import { Icon } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

export function Pagination({ table, perPageSelection, rowsPerPageOptions = [5, 10, 15, 20] }) {
  const { t } = useTranslation();
  const startingPage =
    table.getState().pagination.pageIndex * table.getState().pagination.pageSize + 1;
  const possibleEndingPage =
    table.getState().pagination.pageSize * (table.getState().pagination.pageIndex + 1);
  const totalPage = table.getState().pagination.total || '?';
  const endingPage = totalPage < possibleEndingPage ? totalPage : possibleEndingPage;

  return (
    <S.PaginationWrapper>
      {perPageSelection && (
        <S.RowPerPageWrapper>
          {t('rowsPerPage')}:
          <select
            value={table.getState().pagination.pageSize}
            onChange={e => {
              table.setPageSize(Number(e.target.value));
            }}
          >
            {rowsPerPageOptions.map(pageSize => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </S.RowPerPageWrapper>
      )}
      <S.PaginationSecondGroup>
        <S.PaginationText>{`${startingPage} - ${endingPage} of ${totalPage}`}</S.PaginationText>
        <S.PaginationButtonGroup>
          <S.PaginationButton
            color="secondary"
            variant="text"
            onClick={() => {
              table.setPageIndex(0);
            }}
            disabled={!table.getCanPreviousPage()}
          >
            <Icon name="double-left-chevron" />
          </S.PaginationButton>
          <S.PaginationButton
            color="secondary"
            variant="text"
            onClick={() => {
              table.previousPage();
            }}
            disabled={!table.getCanPreviousPage()}
          >
            <Icon name="left-chevron" />
          </S.PaginationButton>
          <S.PaginationButton
            color="secondary"
            variant="text"
            onClick={() => {
              table.nextPage();
            }}
            disabled={!table.getCanNextPage()}
          >
            <Icon name="right-chevron" />
          </S.PaginationButton>
          <S.PaginationButton
            color="secondary"
            variant="text"
            onClick={() => {
              table.setPageIndex(table.getPageCount() - 1);
            }}
            disabled={!table.getCanNextPage()}
          >
            <Icon name="double-right-chevron" />
          </S.PaginationButton>
        </S.PaginationButtonGroup>
      </S.PaginationSecondGroup>
    </S.PaginationWrapper>
  );
}
